<template>
  <span>
    <span class="btn btn-light" @click="showCreateDOModal">
      <font-awesome-icon icon="plus-circle"/> {{ $t('data_objects.create.button_label') }}
    </span>

    <!-- Edit Process modal template -->
    <b-modal ref="create-data-object" hide-footer @hide="hideCreateDOModal">
      <div class="d-block text-center">
        <h4 qid="update-tp-title">
          {{ $t('data_objects.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-do-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="formSubmit" qid="create-do-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-do-name-label">
              {{ $t('maintenance.data_objects.create.name_label') }}
            </label>
            <b-form-input
              qid="create-do-form-name"
              type="text"
              v-model="doForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.data_objects.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-do-description-label">
              {{ $t('maintenance.data_objects.create.description_label') }}
            </label>
            <b-form-textarea
              qid="create-do-form-description"
              v-model="doForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.data_objects.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="create-do-classification-label">
              {{ $t('maintenance.data_objects.create.classification_label') }}
            </label>
            <multiselect
                v-model="doForm.classification"
                :options="classificationItems"
                :placeholder="$t('maintenance.data_objects.create.classification_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-do-form-classification"
            ></multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-do-business-classification-label">
              {{ $t('maintenance.data_objects.create.business_classification_label') }}
            </label>
            <multiselect
                v-model="doForm.business_classification"
                :options="businessClassificationItems"
                :placeholder="$t('maintenance.data_objects.create.business_classification_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-do-form-business-classification"
            ></multiselect>
          </b-form-group>
          <b-form-group :class="{'multiselect--show-input': categoryInput.length}">
            <label qid="create-do-type-label">
              {{ $t('maintenance.data_objects.create.category_label') }}
            </label>
            <multiselect
                v-model="doForm.category"
                :options="categoryItems"
                :placeholder="$t('maintenance.data_objects.create.category_placeholder')"
                label="category"
                :preserveSearch="true"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="handleCategoryInput"
                qid="create-do-form-category"
            >
              <template slot="noResult" slot-scope="props">
                {{ $t('maintenance.data_objects.create.category_no_results') }}
              </template>
            </multiselect>
          </b-form-group>
          <b-form-group>
            <label qid="create-do-tags-label">
              {{ $t('maintenance.data_objects.create.tags_label') }}
            </label>
            <multiselect
                v-model="selectedTags"
                :options="tags"
                :multiple="true"
                :taggable="true"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                track-by="name_translated"
                :placeholder="$t('maintenance.data_objects.create.tags_placeholder')"
                label="name_translated"
                qid="create-do-tags-select"
                @search-change="loadTags"
                @tag="addTag"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateDOModal"
                    qid="create-do-cancel-button"
          >
            {{ $t('maintenance.data_objects.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    :disabled="buttonDisabled"
                    variant="success"
                    qid="create-do-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.data_objects.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </span>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'DataObjectCreateForm',
    data: function() {
      return {
        doForm: {
          name: '',
          classification: '',
          business_classification: '',
          category: [],
          description: '',
          tags: [],
          client:'',
        },
        error: '',
        inputLink: '',
        tags: [],
        selectedTags: [],
        classificationItems: [
          { name: this.$t('classification.generic_art._6'), value: 'Generic art. 6' },
          { name: this.$t('classification.sensitive_art._9'), value: 'Sensitive art. 9' },
          { name: this.$t('classification.criminal_art._10'), value: 'Criminal art. 10' },
          { name: this.$t('classification.national_identification_number_art._87'), value: 'National identification number art. 87' },
          { name: this.$t('system.n_a'), value: 'N/A' }
        ],
        businessClassificationItems: [
          { name: this.$t('classification.unclassified'), value: 'Unclassified' },
          { name: this.$t('classification.confidential'), value: 'Confidential' },
          { name: this.$t('classification.secret'), value: 'Secret' },
          { name: this.$t('classification.top_secret'), value: 'Top secret' }
        ],
        categoryItems: [],
        categoryInput: '',
        newTags: [],
        buttonDisabled: false
      }
    },
    props: {

    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {

      }
    },
    methods: {
      addTag(newTag) {
        const tag = {
          name: newTag,
          translatable: newTag,
          name_translated: newTag
        }
        this.selectedTags.push(tag)
        this.newTags.push(tag)
      },
      handleCategoryInput(input) {
        this.categoryInput = input;
      },
      showCreateDOModal() {
        let self = this;
        this.loadTags();
        this.loadCategories();
        this.error = ''
        this.$refs['create-data-object'].show()
      },
      hideCreateDOModal() {
        this.newTags = []
        this.doForm.name = ''
        this.doForm.classification = ''
        this.doForm.business_classification = ''
        this.doForm.category = []
        this.doForm.description = ''
        this.doForm.tags = []
        this.selectedTags = []
        this.doForm.client = ''
        this.$refs['create-data-object'].hide()
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        // Append list of countries to FormData
        if (this.selectedTags && this.selectedTags.length) {
          for (var i = 0; i < this.selectedTags.length; i++) {
            formData.append("tags[]", this.selectedTags[i].name_translated);
          }
        }

        formData.append("name", this.doForm.name);
        formData.append("description", this.doForm.description);
        formData.append("client", this.getClient.slug);

        // Additional check - if classification is selected, append it to form data
        if (this.doForm.classification && this.doForm.classification.value) {
          formData.append("classification", this.doForm.classification.value);
        }

        if (this.doForm.business_classification && this.doForm.business_classification.value) {
          formData.append("business_classification", this.doForm.business_classification.value);
        }

        // Additional check - if category is selected, append it to form data
        if (this.doForm.category && this.doForm.category.category) {
          formData.append("category", this.doForm.category.category);
        } else {
          if (this.categoryInput && this.categoryInput.length) {
            formData.append("category", this.categoryInput);
          }
        }

        // Post FormData object to third parties API
        piincHttp.post('/data-objects', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('maintenance.data_objects.create.success'))
          self.hideCreateDOModal();
          self.$emit('updated');
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            // Attach classification error if exists
            if (error.data.errors.classification) {
              self.error += ' ' + self.$t('maintenance.data_objects.create.classification_error')
            }
          }
        })
      },
      loadTags(query) {
        let self = this;
        piincHttp.get('tags', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.tags = response.data
          if (self.tags && !self.tags.length && !query) {
            self.tags.push({name_translated: self.$t('system.no_results'), $isDisabled: true})
          }
          for (var i = 0; i < self.newTags.length; i++) {
            self.tags.push(self.newTags[i]);
          }
        }, function() {});
      },
      loadCategories(query) {
        let self = this;
        piincHttp.get('data-objects/categories', { params:
          {
            client: this.getClient.slug,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.categoryItems = response.data
          if (self.categoryItems && !self.categoryItems.length && !query) {
            self.categoryItems.push({category: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      }
    },
    components: {

    },
    created () {
      if (this.getClient && this.getClient.slug) {

      }
    }
  }
</script>
